import BaseService from './BaseService';
import SignatureBalanceApiAgency from '@/api/SignatureBalanceApiAgency';

class SignatureBalanceService extends BaseService {
	async getCurrentSignatureAsync (...args: Parameters<typeof SignatureBalanceApiAgency.getCurrentSignature>) {
		if (this.self.isAgency()) {
			const { data } = await SignatureBalanceApiAgency.getCurrentSignature(...args);
			return data;
		}
		return [];
	}

	async updateInterlocutorAsync (...args: Parameters<typeof SignatureBalanceApiAgency.updateInterlocutor>) {
		if (this.self.isAgency()) {
			const { data } = await SignatureBalanceApiAgency.updateInterlocutor(...args);
			return data;
		};
	}

	async orderSignatureAsync (...args: Parameters<typeof SignatureBalanceApiAgency.orderSignature>) {
		if (this.self.isAgency()) {
			const { data } = await SignatureBalanceApiAgency.orderSignature(...args);
			return data;
		};
	}
}

export default function useSignatureBalanceService () {
	return new SignatureBalanceService();
}
